import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

type MCStatusBadgeProps = {
  label: string;
  status: "ok" | "warn" | "error";
  tooltip?: string;
};

const STATUS_STYLES: Record<MCStatusBadgeProps["status"], string> = {
  ok: "bg-success/20 text-success border-success/50",
  warn: "bg-warning/20 text-warning border-warning/50",
  error: "bg-destructive/20 text-destructive border-destructive/50",
};

export function MCStatusBadge({ label, status, tooltip }: MCStatusBadgeProps) {
  const badge = (
    <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${STATUS_STYLES[status]}`}>
      {label}
    </span>
  );

  if (!tooltip) {
    return badge;
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent>
          <p className="max-w-xs text-xs text-foreground">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default MCStatusBadge;
